import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 75;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-black/95 backdrop-blur-sm shadow-lg' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="text-2xl font-bold tracking-wider">
            <span className="text-white">RAIDER </span>
            <span className="text-[#CC0000]">WASHING</span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <button 
              onClick={() => scrollToSection('services')}
              className="text-white hover:text-[#CC0000] transition-colors duration-300 font-medium"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('results')}
              className="text-white hover:text-[#CC0000] transition-colors duration-300 font-medium"
            >
              Results
            </button>
            <button 
              onClick={() => scrollToSection('why-us')}
              className="text-white hover:text-[#CC0000] transition-colors duration-300 font-medium"
            >
              Why Us
            </button>
            <button 
              onClick={() => scrollToSection('reviews')}
              className="text-white hover:text-[#CC0000] transition-colors duration-300 font-medium"
            >
              Reviews
            </button>
            <button 
              onClick={() => scrollToSection('quote')}
              className="bg-[#CC0000] text-white px-6 py-2.5 rounded hover:bg-[#B30000] transition-all duration-300 font-semibold shadow-lg hover:shadow-red-900/50"
            >
              Free Quote
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-white"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-[#CC0000]/30">
            <div className="flex flex-col gap-4 mt-4">
              <button 
                onClick={() => scrollToSection('services')}
                className="text-white hover:text-[#CC0000] transition-colors duration-300 font-medium text-left"
              >
                Services
              </button>
              <button 
                onClick={() => scrollToSection('results')}
                className="text-white hover:text-[#CC0000] transition-colors duration-300 font-medium text-left"
              >
                Results
              </button>
              <button 
                onClick={() => scrollToSection('why-us')}
                className="text-white hover:text-[#CC0000] transition-colors duration-300 font-medium text-left"
              >
                Why Us
              </button>
              <button 
                onClick={() => scrollToSection('reviews')}
                className="text-white hover:text-[#CC0000] transition-colors duration-300 font-medium text-left"
              >
                Reviews
              </button>
              <button 
                onClick={() => scrollToSection('quote')}
                className="bg-[#CC0000] text-white px-6 py-2.5 rounded hover:bg-[#B30000] transition-colors duration-300 font-semibold text-left"
              >
                Free Quote
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
